<p-tabs value="tab1">
  <p-tablist>
    <p-tab value="tab1">
      {{ 'common.navigation.setting.title' | translateSafe }}
    </p-tab>
    <p-tab value="tab2">
      {{ 'common.navigation.trigger.title' | translateSafe }}
    </p-tab>
    <p-tab value="tab3">
      {{ 'common.navigation.condition.title' | translateSafe }}
    </p-tab>
    <p-tab value="tab4">
      {{ 'common.navigation.action.title' | translateSafe }}
    </p-tab>
  </p-tablist>

  <p-tabpanels>
    <form class="form"
          [formGroup]="formGroup"
          [class.disabled]="formGroup.disabled">
      <p-tabpanel value="tab1">
        <div class="content">
          <div class="row">
            <app-input-text class="no-icon"
                            [formData]="nameInput"
                            [isLoading]="loading" />

            <app-toggle-switch [formData]="isActiveToggle"
                               [isLoading]="loading" />
          </div>

          <div class="row">
            <app-input-textarea [formData]="descriptionInput"
                                [isLoading]="loading" />
          </div>

          <div class="row">
            <app-input-select [formData]="severitySelect"
                              [isLoading]="loading" />

            <app-input-select [formData]="alarmTypeInput"
                              [isLoading]="loading"
                              scrollHeight="150px" />
          </div>

          <!--<div class="row">
            <app-input-text [formData]="cooldownInput"
                            [isLoading]="loading" />
          </div>-->
        </div>
      </p-tabpanel>

      <p-tabpanel value="tab2">
        <app-alarm-rule-triggers [formGroup]="formGroup"
                                 [isLoading]="loading"
                                 [triggerDefinitions]="triggerDefinitions" />
      </p-tabpanel>

      <p-tabpanel value="tab3">
        <app-alarm-rule-conditions [formGroup]="formGroup"
                                   [mode]="mode"
                                   [conditions]="alarmRule.conditions ?? []"
                                   [isLoading]="loading"
                                   [conditionDefinitions]="conditionDefinitions" />
      </p-tabpanel>

      <p-tabpanel value="tab4">
        <app-alarm-rule-actions [formGroup]="formGroup"
                                [mode]="mode"
                                [actions]="alarmRule.actions ?? []"
                                [isLoading]="loading"
                                [actionDefinitions]="actionDefinitions" />
      </p-tabpanel>

      @if (mode === 'override') {
        <app-input-submit [formData]="submitButton"
                          (click)="override()" />
      }
    </form>
  </p-tabpanels>
</p-tabs>
